import { IValidationRule } from "@/types"

const locationValidationRules: { [s: string]: IValidationRule } = {
    description: {
        required: true
    },
}

export default locationValidationRules
